import { Target, Compass } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import Reveal, { fadeUp } from "@/components/motion/Reveal";

export default function VisionMission() {
  const { t } = useI18n();
  return (
    <section data-testid="vision-mission-section" className="section-pad bg-surface-muted relative">
      <div className="absolute inset-0 noise-overlay pointer-events-none" aria-hidden />
      <div className="container-pro relative">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          <Card
            icon={<Compass size={20} />}
            kicker={t.vision.kicker}
            title={t.vision.title}
            body={<p>{t.vision.body}</p>}
            testid="vision-card"
          />
          <Card
            icon={<Target size={20} />}
            kicker={t.mission.kicker}
            title={t.mission.title}
            body={
              <ul className="space-y-2.5 text-ink-secondary">
                {t.mission.items.map((it, i) => (
                  <li key={i} className="flex gap-3"><Dot /> {it}</li>
                ))}
              </ul>
            }
            testid="mission-card"
          />
        </div>
      </div>
    </section>
  );
}

const Dot = () => <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-red" />;

const Card = ({ icon, kicker, title, body, testid }) => (
  <Reveal variants={fadeUp} className="h-full">
    <div data-testid={testid} className="glow-card relative h-full bg-white border border-line rounded-xl p-8 md:p-10 overflow-hidden">
      <div className="absolute top-0 end-0 h-16 w-16 ticker opacity-50" aria-hidden />
      <div className="flex items-center gap-3">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-brand-black text-white">{icon}</span>
        <span className="overline">{kicker}</span>
      </div>
      <h3 className="mt-5 font-heading text-2xl md:text-3xl font-medium tracking-tight leading-tight">{title}</h3>
      <div className="mt-5 text-base leading-relaxed text-ink-secondary">{body}</div>
    </div>
  </Reveal>
);
